// extracted by mini-css-extract-plugin
export default {"card":"stationCard_card__1WjYA","count":"stationCard_count__RXTXG"};